import {
    Component,
    HostBinding,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'fe-card-landing-title',
    templateUrl: './card-landing-title.component.html',
    styleUrls: ['./card-landing-title.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CardLandingTitleComponent {
    @Input() title?: string | null;
    @Input() imageSrc!: string;

    @HostBinding('class.container-card-landing-title')
    private containerCardLadingTitleClass = true;

    @HostBinding('class.position-relative') private positionRelativeClass =
        true;

    @HostBinding('class.d-block') private dBlockClass = true;
}
